import Logger from '../logger/logger';

export default class OidcLogger {
    debug(...args: unknown[]): void {
        Logger.debug([ 'session', 'oidc' ], args.join(' '));
    }

    info(...args: unknown[]): void {
        Logger.info([ 'session', 'oidc' ], args.join(' '));
    }

    warn(...args: unknown[]): void {
        Logger.warn([ 'session', 'oidc' ], args.join(' '));
    }

    error(...args: unknown[]): void {
        Logger.error([ 'session', 'oidc' ], args.join(' '));
    }
}
